import { connect, useDataItem } from 'scrivito'

import { DocumentTabConfig } from './DocumentTabConfig'
import { DocumentsList } from '@/Components/Document/DocumentsList/DocumentsList'
import { DocumentRelationType } from '@/Components/Document/types'
import { ErrorVariant } from '@/Components/error/constants'
import { ErrorPage } from '@/Components/error/Errors'
import { DataClassName } from '@/Data/const'
import { DocumentProvider } from '@/hooks/documents/useDocumentHandler'
import { getSchemaName } from '@/utils/dataClassMap'
import { getSchema } from '@/utils/getSchema'
import { reportError } from '@/utils/reportError'

import '../../../../../Components/Document/DocumentsTab.scss'

interface DocumentTabProps {
  relationTo: DocumentRelationType
}

export const DocumentTab: React.FC<DocumentTabProps> = connect(
  ({ relationTo }) => {
    const subject = useDataItem()

    const { schema, error: schemaError } = getSchema(
      getSchemaName(DataClassName.DOCUMENT),
    )

    if (schemaError) {
      reportError(schemaError)
      return <ErrorPage variant={ErrorVariant.InternalServerError} />
    }

    if (!schema || !subject) return

    return (
      <DocumentProvider entity={subject} relationTo={relationTo}>
        <div className="documents-tab">
          <DocumentTabConfig />
          <ul>
            <DocumentsList schema={schema} />
          </ul>
        </div>
      </DocumentProvider>
    )
  },
)
